import * as staticSchema from "#schema";

export { staticRelations } from "#relations";

export type StaticTables = {
  [$Key in keyof typeof staticSchema]: (typeof staticSchema)[$Key]["$inferSelect"][];
};
